module.exports = __webpack_public_path__ + "img/pdf.e43797ab.svg";